
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telus/blog/[blog]",
      function () {
        return require("private-next-pages/telus/blog/[blog]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telus/blog/[blog]"])
      });
    }
  